/*
 * Public API Surface of surf-dp-add-bar
 */

export * from './lib/dp-add-bar/dp-add-bar.component';
export * from './lib/surf-dp-add-bar.service';
export * from './lib/surf-dp-add-bar.module';
